export default __webpack_public_path__ + "static/media/right-design.d825f5c1.svg";